<tabs>
  <tab *ngFor="let tab of navigationPanel; let i = index;" [title]="tab.title" [active]="i === 0"
    [tabname]="tab.tabname" [tabKey]="tab.tabKey" [ngStyle]="{'flex-grow': (tab.tabKey === selectedTab) ? 1 : 0}">
    <div>
      <nav-loader [navItem]="{component: tab.component, data: tab.data, tabKey: tab.tabKey}">
      </nav-loader>
    </div>
  </tab>
</tabs>